'use client';

import Link from '@eliadmin/core/src/components/link';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

export function Breadcrumbs({ product }: { product: ProductDetailData }) {
  const { t } = useTranslations();

  return (
    <div
      className={cn(
        'flex w-full flex-wrap items-center justify-start gap-2 whitespace-nowrap text-sm text-primary sm:text-base',
        'ea-product-header__breadcrumbs-container',
      )}
    >
      <Link prefetch={false} href={ROUTES.HOME()}>
        {t('text160')}
      </Link>
      <span>{'<'}</span>
      {product?.categories?.length && (
        <Link prefetch={false} href={ROUTES.CATEGORY({ slug: product.categories[0]?.slug })}>
          {product.categories[0]?.name}
        </Link>
      )}
      <span>{'<'}</span>
      <Link prefetch={false} href={ROUTES.PRODUCT({ slug: product.slug })}>
        {product.name}
      </Link>
    </div>
  );
}
